import React from "react";

/**
 * The Save button of a long form in a dialog. On a phone it stays pinned to the
 * bottom of the dialog instead of waiting at the end of a long scroll. Place it
 * inside the `<Form>`, after the `<FormLayout>`: sticky only works inside a
 * parent that is as tall as the whole form.
 */
const StickyFormFooter: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className="mt-4 max-md:sticky max-md:bottom-0 max-md:z-10 max-md:-mx-4 max-md:border-t max-md:border-gray-200 max-md:bg-white max-md:px-4 max-md:py-3">
    {children}
  </div>
);

export default StickyFormFooter;
